import * as React from "react";

;
export const PlusLogo = (props: React.SVGProps<SVGSVGElement>) => <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.625 6.375V11h.75V6.375H11v-.75H6.375V1h-.75v4.625H1v.75h4.625z" /></svg>;